import styled from 'styled-components';

export const StyledDropdown = styled.select<{ disabled?: boolean }>`
  width: 100%;
  box-sizing: content-box;
  background-color: ${({ disabled, theme }): string =>
    disabled ? theme.palette_gray_5 : theme.palette_white};
  border-width: 2px;
  border-style: solid;
  border-color: ${({ theme }): string => theme.palette_gray_5};
  border-radius: ${({ theme }): string => theme.border_radius_x1};
  height: ${({ theme }): string => theme.spacing_unit_x4};
  margin-top: ${({ theme }): string => theme.border_radius_x2};
`;
